<template>
  <node :title="config.name" :show-error="showError" :content="content" :error-info="errorInfo" placeholder="请设置审批人" header-bgc="#ff943e" header-icon="el-icon-s-check" @selected="$emit('selected')" @delNode="$emit('delNode')" @insertNode="type => $emit('insertNode', type)" />
</template>

<script>
import Node from './Node';

export default {
  name: 'ApprovalNode',
  components: { Node },
  props: {
    config: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      showError: false,
      errorInfo: ''
    };
  },
  computed: {
    content() {
      const config = this.config.props;
      if (config.operation_roles.length === 0) {
        return '未设置审批事项';
      } else {
        return config.operation_roles.map(item => item.description).join('; ');
      }
    }
  },
  methods: {
    getFormItemById(id) {
      return this.$store.state.design.formItems.find(item => item.id === id);
    },
    // 校验数据配置的合法性
    validate(err) {
      try {
        return (this.showError = !this[`validate_${this.config.props.assignedType}`](err));
      } catch (e) {
        return true;
      }
    },
    validate_ASSIGN_USER(err) {
      if (this.config.props.assignedUser.length > 0) {
        return true;
      } else {
        this.errorInfo = '请指定审批人员';
        err.push(`${this.config.name} 未指定审批人员`);
        return false;
      }
    },
    validate_SELF_SELECT(err) {
      console.log(err);
      return true;
    },
    validate_LEADER_TOP(err) {
      console.log(err);
      return true;
    },
    validate_LEADER(err) {
      console.log(err);
      return true;
    },
    validate_ROLE(err) {
      if (this.config.props.role.length <= 0) {
        this.errorInfo = '请指定负责审批的系统角色';
        err.push(`${this.config.name} 未指定审批角色`);
        return false;
      }
      return true;
    },
    validate_SELF(err) {
      console.log(err);
      return true;
    },
    validate_FORM_USER(err) {
      if (this.config.props.formUser === '') {
        this.errorInfo = '请指定表单中的人员组件';
        err.push(`${this.config.name} 审批人为表单中人员，但未指定`);
        return false;
      }
      return true;
    },
    validate_REFUSE(err) {
      console.log(err);
      return true;
    }
  }
};
</script>

<style scoped></style>
